const getFormattedMessage = (message?: string, ...optionalParams: any[]) => {
    const timestamp = new Date().toLocaleString();
  
    // Construct the formatted message
    const formattedParams = optionalParams.length
      ? optionalParams
          .map((param) =>
            typeof param === "string" ? param : JSON.stringify(param),
          )
          .join(" ")
      : "";
  
    const formattedMessage =
      `[${timestamp}] ${message || ""} ${formattedParams}`.trim();
    return formattedMessage;
  };
  
  export const logInfoWithTimestamp = (
    message?: string,
    ...optionalParams: any[]
  ) => {
    console.log(getFormattedMessage(message, ...optionalParams));
  };
  
  export const logErrorWithTimestamp = (
    message?: string,
    ...optionalParams: any[]
  ) => {
    console.error(getFormattedMessage(message, ...optionalParams));
  };
  